// 我的群组页面
import React, { useState, useEffect } from "react";
//import "./index.less";

import { IItemData } from "./common.typing";
import PageTitle from "./PageTitle";
import CommonList from "./CommonList";
import GroupList from "./GroupList";
import locale from "../../_util/locale";

export interface IMyGroupProps {
    prePage: string;
    type?: string;
    onChangeCurPage: (page: string) => void;
    onChangePrePage: (page: string) => void;
    currentList: IItemData[];
    setCurrentList: (list: IItemData[]) => void;
    getMyGroupList?: () => void;
    myGroupList: IItemData[];
    setCurrentGroupInfo: (group: { id: number | string; name: string }) => void;
    disabledids?: string[];
    requiredList?: IItemData[];
    multiple?: boolean;
}

const MyGroup: React.FC<IMyGroupProps> = ({
    prePage,
    type,
    onChangeCurPage,
    onChangePrePage,
    currentList,
    setCurrentList,
    myGroupList,
    getMyGroupList,
    setCurrentGroupInfo,
    disabledids,
    requiredList,
    multiple,
}) => {
    useEffect(() => {
        getMyGroupList && getMyGroupList();
    }, []);

    /**
     * pageTitle 返回
     * prePage: home
     */
    const onBack = () => {
        onChangeCurPage(prePage);
    };

    /**
     * 群组展示形式的点击时间
     * @param id 群 id
     */
    const onClickGroup = (id: number | string, name: string) => {
        setCurrentGroupInfo({ id, name });
        onChangeCurPage("groupMember");
        onChangePrePage("myGroup");
    };

    const onClickPartner = async (id: number | string, name: string) => {
        setCurrentGroupInfo({ id, name });
        onChangeCurPage("groupMember");
        onChangePrePage("myGroup");
    };

    return (
        <div className="myGroup">
            {/* <PageTitle
                {...{
                    title: locale("useradd_type_group"),
                    onBack,
                }}
            /> */}
            {type === "member" ? (
                <CommonList
                    {...{
                        type: "group",
                        pikerType: type,
                        list: myGroupList,
                        currentList,
                        setCurrentList,
                        disabledids,
                        requiredList,
                        multiple,
                        onClickPartner,
                    }}
                />
            ) : (
                <CommonList
                    {...{
                        type: "group",
                        pikerType: type,
                        list: myGroupList,
                        currentList,
                        setCurrentList,
                        disabledids,
                        requiredList,
                        multiple,
                        onClickPartner,
                    }}
                />
            )}
        </div>
    );
};

export default MyGroup;
